"use client";

import { isServer } from "@/env/config";

export const safeWindow: Window | undefined = isServer() ? undefined : window;
